// extracted by mini-css-extract-plugin
export default {"TableView":"EmployeeTable_TableView__xYu0Q","Cell":"EmployeeTable_Cell__5MvR8","Paper":"EmployeeTable_Paper__Xs3Hd"};